module.exports = __webpack_public_path__ + "img/list_agent_default.9d705172.png";